<div class="container-fluid se-form">

  <!-- ── CABECERA ── -->
  <div class="tf-page-header">
    <div class="d-flex align-items-center gap-2">
      <h4 class="tf-page-title mb-0">Recibo de autónomo</h4>
      <ng-container *ngIf="saved">
        <mat-icon class="text-success">check_circle</mat-icon>
      </ng-container>
    </div>
    <button mat-stroked-button class="btn-convfact" (click)="save(selfEmployed)">
      <mat-icon>save</mat-icon> Guardar
    </button>
  </div>

  <div *ngIf="ready">

    <!-- ── CARD: DATOS ── -->
    <mat-card appearance="outlined" class="tf-card mb-3">
      <mat-card-content>

        <div class="tf-section-header">
          <h6 class="tf-section-title">Datos del recibo</h6>
        </div>

        <div class="row g-3">

          <!-- Concepto -->
          <div class="col-sm-6 col-xl-4">
            <app-input inputType="text" placeholder="Concepto" name="selfEmployed.concept" [isRequired]="true"
              [(ngModel)]="selfEmployed.concept"></app-input>
          </div>

          <!-- Fecha -->
          <div class="col-sm-6 col-xl-4">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Fecha</mat-label>
              <input matInput [matDatepicker]="date" name="selfEmployed.date"
                [(ngModel)]="selfEmployed.date" required>
              <mat-datepicker-toggle matSuffix [for]="date"></mat-datepicker-toggle>
              <mat-datepicker #date></mat-datepicker>
            </mat-form-field>
          </div>

          <!-- Fecha de pago -->
          <div class="col-sm-6 col-xl-4">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Fecha de pago</mat-label>
              <input matInput [matDatepicker]="paided" name="selfEmployed.paided"
                [(ngModel)]="selfEmployed.paided" required>
              <mat-datepicker-toggle matSuffix [for]="paided"></mat-datepicker-toggle>
              <mat-datepicker #paided></mat-datepicker>
            </mat-form-field>
          </div>

        </div>
      </mat-card-content>
    </mat-card>

    <!-- ── CARD: IMPORTE Y PAGO ── -->
    <mat-card appearance="outlined" class="tf-card mb-3">
      <mat-card-content>

        <div class="tf-section-header">
          <h6 class="tf-section-title">Importe y método de pago</h6>
        </div>

        <div class="row g-3">

          <!-- Cantidad -->
          <div class="col-sm-6 col-xl-3">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Cantidad</mat-label>
              <mat-icon matSuffix class="se-euro-icon">attach_money</mat-icon>
              <input type="text" matInput name="selfEmployed.amount" required
                [(ngModel)]="selfEmployed.amount" numberDecimalsDirective>
            </mat-form-field>
          </div>

          <!-- Recargo -->
          <div class="col-sm-6 col-xl-3">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Recargo de pago autónomo</mat-label>
              <mat-icon matSuffix class="se-euro-icon">attach_money</mat-icon>
              <input type="text" matInput name="selfEmployed.recargo" required
                [(ngModel)]="selfEmployed.recargo" numberDecimalsDirective>
            </mat-form-field>
          </div>

          <!-- Tipo de pago -->
          <div class="col-sm-6 col-xl-3">
            <app-select name="selfEmployed.typePay" [(ngModel)]="selfEmployed.typePay"
              (ngModelChange)="selectionChangeTypePay($event)"
              [config]="{ label: 'Tipo de pago', placeholder: 'Seleccionar', required: true, options: payMethodsOptions }">
            </app-select>
          </div>

          <!-- Caja / Efectivo -->
          <div class="col-sm-6 col-xl-3" *ngIf="selfEmployed.typePay === 'Efectivo'">
            <app-autocomplete-select
              [items]="efectivoList" [(selectedItemId)]="selfEmployed.efectivoId"
              [idField]="'uid'" [displayField]="'nombre'"
              placeholder="Caja / Efectivo" [classList]="'se-field-full'">
            </app-autocomplete-select>
          </div>

          <!-- Póliza de crédito -->
          <div class="col-sm-6 col-xl-3" *ngIf="selfEmployed.typePay === 'Póliza de crédito'">
            <app-autocomplete-select
              [items]="polizaCreditoList" [(selectedItemId)]="selfEmployed.polizaCreditoId"
              [idField]="'uid'" [displayField]="'banco'"
              placeholder="Póliza de crédito" [classList]="'se-field-full'">
            </app-autocomplete-select>
          </div>

          <!-- Socios -->
          <div class="col-sm-6 col-xl-3" *ngIf="selfEmployed.typePay === 'Socio'">
            <app-autocomplete-select
              [items]="sociosList" [(selectedItemId)]="selfEmployed.partnersId"
              [idField]="'uid'" [displayField]="'nameOrBusinessName'"
              placeholder="Socio" [classList]="'se-field-full'">
            </app-autocomplete-select>
          </div>

          <!-- Cuentas bancarias -->
          <div class="col-sm-6 col-xl-3"
            *ngIf="selfEmployed.typePay === 'Transferencia bancaria'
                || selfEmployed.typePay === 'Cargo en cuenta'
                || selfEmployed.typePay === 'Confirming'
                || selfEmployed.typePay === 'Pagarés'">
            <app-autocomplete-select
              [items]="bankAccounts" [(selectedItemId)]="selfEmployed.typePayBankAccount"
              [idField]="'uid'" [displayFields]="['bank', 'iban']"
              placeholder="Cuenta bancaria" [classList]="'se-field-full'">
            </app-autocomplete-select>
          </div>

          <!-- Tarjeta de crédito -->
          <div class="col-sm-6 col-xl-3" *ngIf="selfEmployed.typePay === 'Tarjeta de crédito'">
            <app-autocomplete-select
              [items]="paymentCards" [(selectedItemId)]="selfEmployed.typePayBankAccount"
              [idField]="'uid'" [displayFields]="['name', 'number']"
              placeholder="Tarjeta de crédito" [classList]="'se-field-full'">
            </app-autocomplete-select>
          </div>

          <!-- Tarjeta de débito -->
          <div class="col-sm-6 col-xl-3" *ngIf="selfEmployed.typePay === 'Tarjeta de débito'">
            <app-autocomplete-select
              [items]="paymentCards" [(selectedItemId)]="selfEmployed.typePayBankAccount"
              [idField]="'uid'" [displayFields]="['name', 'number']"
              placeholder="Tarjeta de débito" [classList]="'se-field-full'">
            </app-autocomplete-select>
          </div>

        </div>
      </mat-card-content>
    </mat-card>

  </div>

</div>
